module.exports = __webpack_public_path__ + "img/SmallPause.58ac1a8b.svg";